import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Profile} from "../../../common/common-profile/models/profile.model";
import {Product} from "../../models/product.model";
import {ProductVariantShort} from "../../../common/common-product/models/product-short.model";
import {Contract} from "../../../snatch/models/contract.model";
import {CommonPricingQueryModel} from "../../models/bundle.model";

@Component({
  selector: 'leap-product-cart-form-generic-details',
  templateUrl: './product-cart-form-generic-details.component.html',
  styleUrls: ['./product-cart-form-generic-details.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCartFormGenericDetailsComponent {

  @Input() profile: Profile;
  @Input() product: Product;
  @Input() selectedVariant: ProductVariantShort;
  @Input() expiringContract: Contract;
  @Input() details: Product;
  @Input() isProductBundle: boolean;

  @Input() currencySign: any;
  @Input() basePrice: any;
  @Input() surchargeTotalAmount: any;
  @Input() isPromotionPricingApplied: boolean;
  @Input() actualBasePrice: number;
  @Input() promotionPricingDiscountEndDate : string;
  @Input() licenseForm: CommonPricingQueryModel;

  constructor() { }
}
